/** 설문 문항 타입 */
export enum SURVEY_ITEM_TYPE {
  /** 단답형 - 이름, 연락처 등 짧은 텍스트 입력 */
  SHORT_ANSWER = 'SHORT_ANSWER',
  /** 장문형 - 의견, 피드백 등 긴 서술형 텍스트 입력 */
  PARAGRAPH = 'PARAGRAPH',
  /** 객관식 질문 - 여러 선택지 중 단일 선택 */
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  /** 체크박스 - 여러 선택지 중 다중 선택(복수 응답) */
  CHECKBOX = 'CHECKBOX',
  /** 드롭다운 - 클릭 시 펼쳐지는 목록에서 단일 선택 */
  DROPDOWN = 'DROPDOWN',
  /** 파일 업로드 - 이력서, 이미지 등의 파일 첨부 */
  FILE_UPLOAD = 'FILE_UPLOAD',
  /** 선형 배율 - 1~5점 등 점수나 척도를 선택하는 평가 */
  LINEAR_SCALE = 'LINEAR_SCALE',
  /** 날짜 - 연, 월, 일 등 날짜 입력 */
  DATE = 'DATE',
  /** 시간 - 특정 시각이나 소요 시간 입력 */
  TIME = 'TIME',
}

/** 게시판 타입 */
export enum POST_TYPE {
  /** 몰 공지사항 */
  NOTICE = 13,
  /** 몰 자주 묻는 질문 */
  FAQ = 14,
  /** 상품 문의 */
  PRODUCT_QNA = 15,

  COMMUNITY = 5,
  INQUIRY = 6,
}

/** 유저 권한 */
export enum USER_ROLE {
  /** 정상 사용자 */
  USER = 'USER',
  /** 소셜 가입대기 */
  SOCIAL_GUEST = 'SOCIAL_GUEST',
}

/** 성별 */
export enum USER_GENDER {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  // OTHER = 'OTHER',
}

/** 성별 문구 */
export const USER_GENDERS: { [key in USER_GENDER]: string } = {
  [USER_GENDER.FEMALE]: '여성',
  [USER_GENDER.MALE]: '남성',
  // [USER_GENDER.OTHER]: 'Other',
}

/** 로그인 타입 */
export enum LOGIN_TYPE {
  DEFAULT = 'DEFAULT',
  GOOGLE = 'GOOGLE',
  NAVER = 'NAVER',
  KAKAO = 'KAKAO',
  APPLE = 'APPLE',
}

/** 로그인 타입명 */
export const LOGIN_TYPES: { [key in LOGIN_TYPE]: string } = {
  [LOGIN_TYPE.DEFAULT]: '',
  [LOGIN_TYPE.GOOGLE]: '구글',
  [LOGIN_TYPE.KAKAO]: '카카오톡',
  [LOGIN_TYPE.NAVER]: '네이버',
  [LOGIN_TYPE.APPLE]: '애플',
}

/** OS 구분 */
export enum OS_TYPE {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  // WEB = 'WEB',
}

/** 인증 수단 */
export enum AUTH_METHOD {
  EMAIL = 'EMAIL',
}

/** 인증 용도 */
export enum AUTH_ACTION {
  REGISTER = 'REGISTER',
  PW_RENEW = 'PW_RENEW',
  ID_RENEW = 'ID_RENEW',
}

/** 기본 상태값 */
export enum DEFAULT_STATE {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

/** 약관 타입 */
export enum TERMS_TYPE {
  // 회원가입 ===================>

  /** 서비스 이용약관 */
  TERMS_OF_USE = 'TERMS_OF_USE',
  /** 개인정보 처리 방침 */
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  /** 마케팅 수신동의 */
  MARKETING_CONSENT = 'MARKETING_CONSENT',

  // 카드등록 ===================>

  /** 금융사 개인정보 제공 동의 */
  FINANCIAL_INSTITUTION_THIRD_PARTY_CONSENT = 'FINANCIAL_INSTITUTION_THIRD_PARTY_CONSENT',
  /** 개인정보 제3자 제공동의 */
  PERSONAL_INFORMATION_THIRD_PARTY_CONSENT = 'PERSONAL_INFORMATION_THIRD_PARTY_CONSENT',
  /** 개인정보 수집 및 이용동의 */
  PERSONAL_INFORMATION_COLLECTION_AND_USAGE_CONSENT = 'PERSONAL_INFORMATION_COLLECTION_AND_USAGE_CONSENT',
  /** 전자결제대행 이용동의 */
  PG_SERVICE_USAGE_CONSENT = 'PG_SERVICE_USAGE_CONSENT',
}

/** 약관명 */
export const TERMS_TYPES: { [key in TERMS_TYPE]: string } = {
  [TERMS_TYPE.TERMS_OF_USE]: '이용약관',
  [TERMS_TYPE.PRIVACY_POLICY]: '개인정보처리방침',
  [TERMS_TYPE.MARKETING_CONSENT]: '마케팅 정보 수신 동의',
  [TERMS_TYPE.FINANCIAL_INSTITUTION_THIRD_PARTY_CONSENT]: '금융사 개인정보 제공 동의',
  [TERMS_TYPE.PERSONAL_INFORMATION_THIRD_PARTY_CONSENT]: '개인정보 제3자 제공동의',
  [TERMS_TYPE.PERSONAL_INFORMATION_COLLECTION_AND_USAGE_CONSENT]: '개인정보 수집 및 이용동의',
  [TERMS_TYPE.PG_SERVICE_USAGE_CONSENT]: '전자결제대행 이용동의',
}

/** 로그인 찾기 구분 */
export enum LOGIN_FIND_TYPE {
  EMAIL = 'email',
  PASSWORD = 'password',
}

/** 한국 국가 아이디 */
export const KOREA_COUNTRY_ID = 162

/** 배너 타입 */
export enum BANNER_TYPE {
  IMAGE = 'IMAGE',
  YOUTUBE = 'YOUTUBE',
}

/** 배너 위치 */
export enum BANNER_POSITION {
  /** 홈 메인 배너 */
  HOME_MAIN = 'SHOP_MAIN',
  /** 홈 팝업 배너 */
  HOME_POPUP = 'SHOP_MAIN_POPUP',
  /** 홈 중간 배너 */
  HOME_MAIN_MIDDLE = 'SHOP_MAIN_MIDDLE',
}

/** SNS 구분 */
export enum SNS_TYPE {
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  TikTok = 'TikTok',
  X = 'X (Twitter)',
  YouTube = 'YouTube',
  Other = 'Other',
}

/** 푸터 SNS 타입 */
export enum FOOTER_SNS_TYPE {
  /** 카카오톡 */
  KAKAO = 'kakao',
  /** 유튜브 */
  YOUTUBE = 'youtube',
  /** 인스타그램 */
  INSTAGRAM = 'instagram',
  /** 네이버 블로그 */
  NAVER_BLOG = 'naver_blog',
  /** 스레드 */
  THREADS = 'threads',
  /** 페이스북 */
  FACEBOOK = 'facebook',
}

/** 푸터 SNS 타입명 */
export const FOOTER_SNS_TYPES: { [key in FOOTER_SNS_TYPE]: string } = {
  [FOOTER_SNS_TYPE.KAKAO]: '카카오톡',
  [FOOTER_SNS_TYPE.YOUTUBE]: '유튜브',
  [FOOTER_SNS_TYPE.INSTAGRAM]: '인스타그램',
  [FOOTER_SNS_TYPE.NAVER_BLOG]: '네이버 블로그',
  [FOOTER_SNS_TYPE.THREADS]: '스레드',
  [FOOTER_SNS_TYPE.FACEBOOK]: '페이스북',
}

/** 환경구성 아이디 */
export enum CONFIG_IDS {
  /** 홈페이지 설정 */
  HOMEPAGE_CONFIGS = 'HOMEPAGE_CONFIGS',
  /** 추천 검색어 */
  RECOMMENDED_SEARCH_KEYWORDS = 'RECOMMENDED_SEARCH_KEYWORDS',
  /** 배송요청 상용구 */
  DELIVERY_COMMENTS = 'DELIVERY_COMMENTS',
  /** 주문 취소 사유 */
  SHOP_ORDER_CANCEL_REASONS = 'SHOP_ORDER_CANCEL_REASONS',

  /** 푸터 내용 */
  FOOTER_CONFIG = 'FOOTER_CONFIG',

  /** SNS 링크 */
  SNS_LINKS_CONFIG = 'SNS_LINKS_CONFIG',

  /** 고객 센터 */
  CUSTOMER_CENTER_CONFIG = 'CUSTOMER_CENTER_CONFIG',
  /** 회사 정보 */
  COMPANY_INFO_CONFIG = 'COMPANY_INFO_CONFIG',
  /** 회사 로고 */
  COMPANY_LOGO_CONFIG = 'COMPANY_LOGO_CONFIG',
}

/** 리뷰 평점 */
export enum RATING_TYPE {
  VERY_DISSATISFIED = 1,
  DISSATISFIED = 2,
  NEUTRAL = 3,
  SATISFIED = 4,
  VERY_SATISFIED = 5,
}

/** 통신사 타입 */
export enum CARRIER_TYPE {
  SKT = 'SKT',
  KT = 'KT',
  LGT = 'LGT',
}

/** 통신사 문구 */
export const CARRIER_TYPES: { [key in CARRIER_TYPE]: string } = {
  [CARRIER_TYPE.SKT]: 'SKT',
  [CARRIER_TYPE.KT]: 'KT',
  [CARRIER_TYPE.LGT]: 'LG U+',
}

/** 상품 페이지 기본 페이지 크기 */
export const PRODUCTS_TAKE_DEFAULT = 24

/** LIMIT 기본값 */
export const MAX_TAKE = 100
export const LIMIT_OPTION = [10, 15, 20, 50, MAX_TAKE]

/** 홈페이지 레이아웃 타입 (IHomePageLayout.type) */
export enum HOME_LAYOUT_TYPE {
  /** 게시물(목록) 레이아웃 */
  POST = 'POST',
  /** 일반 레이아웃 */
  DEFAULT = 'DEFAULT',
}

/** 포인트 타입 */
export enum POINT_TYPE {
  SAVED = 'SAVED',
  USED = 'USED',
  CANCELED_USE = 'CANCELED_USE',
  DEBITED = 'DEBITED',
  EXPIRED = 'EXPIRED',
}

export const POINT_TYPES: { [key in POINT_TYPE]: string } = {
  [POINT_TYPE.SAVED]: '적립',
  [POINT_TYPE.USED]: '사용',
  [POINT_TYPE.CANCELED_USE]: '사용취소',
  [POINT_TYPE.DEBITED]: '회수',
  [POINT_TYPE.EXPIRED]: '만료',
}

/** 카드 구분 */
export enum CARD_TYPE {
  CREDIT = 0,
  CHECK = 1,
}

export const CARD_TYPES: { [key in CARD_TYPE]: string } = {
  [CARD_TYPE.CREDIT]: '신용카드',
  [CARD_TYPE.CHECK]: '체크카드',
}

/** 상품 유형 */
export enum PRODUCT_ASSORTMENT {
  /** 일반 상품 */
  BASIC = 'BASIC',
  /** 장애인 보조기기(지원사업) */
  DISABILITY_AID = 'DISABILITY_AID',
  /** 노인복지용구(지원사업) */
  ELDERLY_WELFARE = 'ELDERLY_WELFARE',
}

export const PRODUCT_ASSORTMENTS: { [key in PRODUCT_ASSORTMENT]: string } = {
  [PRODUCT_ASSORTMENT.BASIC]: '',
  [PRODUCT_ASSORTMENT.DISABILITY_AID]: '장애인 보조기기',
  [PRODUCT_ASSORTMENT.ELDERLY_WELFARE]: '노인복지용구',
}

/** 상품 옵션 상태 */
export enum PRODUCT_OPTION_STATE {
  ENABLE = 'ENABLE',
  DISABLE = 'DISABLE',
  SOLD_OUT = 'SOLD_OUT',
}

export const PRODUCT_OPTION_STATES: { [key in PRODUCT_OPTION_STATE]: string } = {
  [PRODUCT_OPTION_STATE.ENABLE]: '노출',
  [PRODUCT_OPTION_STATE.DISABLE]: '비노출',
  [PRODUCT_OPTION_STATE.SOLD_OUT]: '품절',
}

/** 주문 구분 */
export enum ORDER_TYPE {
  /** 일반 주문 */
  DEFAULT = 'DEFAULT',
  /** 장바구니 주문 */
  CART = 'CART',
  /** 상담 구매 주문 */
  CONSULT = 'CONSULT',
}

/** 주문 상태 */
export enum ORDER_STATE {
  /** 주문 대기 */
  PENDING = 'PENDING',
  /** 입금 대기 */
  DEPOSIT_WAITING = 'DEPOSIT_WAITING',
  /** 결제 완료 */
  PAID = 'PAID',
  /** 주문 취소 */
  CANCELLED = 'CANCELLED',
  /** 결제 실패 */
  // FAILED = 'FAILED',
}

/** 주문 상품옵션 상태 */
export enum ORDER_OPTION_STATE {
  /** 대기 */
  PENDING = 'PENDING',
  /** 상품준비중(발주확인) */
  ORDERED = 'ORDERED',
  /** 배송중 */
  SHIPPING = 'SHIPPING',
  /** 배송완료 */
  DELIVERED = 'DELIVERED',
  /** 취소 */
  CANCELLED = 'CANCELLED',
  /** 반품 요청 */
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  /** 반품중 */
  RETURNING = 'RETURNING',
  /** 반품 완료 */
  RETURNED = 'RETURNED',
  /** 교환 요청 */
  EXCHANGE_REQUESTED = 'EXCHANGE_REQUESTED',
  /** 교환중 */
  EXCHANGING = 'EXCHANGING',
  /** 교환 완료 */
  EXCHANGED = 'EXCHANGED',
}

/** 결제 타입 */
export enum PAYMENT_TYPE {
  RESERVATION = 'RESERVATION',
  OVERTIME = 'OVERTIME',
  ADDITIONAL = 'ADDITIONAL',
  SHOP = 'SHOP',
}

/** 결제 상태 */
export enum PAYMENT_HISTORY_STATE {
  READY = 'READY',
  PAID = 'PAID',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

/** 배송 유형 */
export enum DELIVERY_TYPE {
  /** 직배송 */
  DIRECT_DELIVERY = 'DIRECT_DELIVERY',
  /** 우편/택배/퀵서비스 */
  PARCEL_POST = 'PARCEL_POST',
  /** 현장수령 */
  // PICKUP = 'PICKUP',
}

export const DELIVERY_TYPES: { [key in DELIVERY_TYPE]: string } = {
  [DELIVERY_TYPE.DIRECT_DELIVERY]: '직접배송',
  [DELIVERY_TYPE.PARCEL_POST]: '택배배송',
  // [DELIVERY_TYPE.PICKUP]: '현장수령',
}

/** 배송비 유형 */
export enum DELIVERY_FEE_TYPE {
  /** 무료 */
  FREE = 'FREE',
  /** 고정 */
  PAID = 'PAID',
  /** 수량 */
  PER_ITEM = 'PER_ITEM',
}

/** 상품 과세 유형 */
export enum PRODUCT_TAX_TYPE {
  /** 과세 */
  TAXABLE = 'TAXABLE',
  /** 영세 */
  ZERO_RATED = 'ZERO_RATED',
  /** 면세 */
  EXEMPT = 'EXEMPT',
}

/** 상품 태그 아이디 */
export enum PRODUCT_TAG_ID {
  /** 신상 */
  NEW = 1,
  /** 특별할인 */
  SPECIAL_DISCOUNT = 2,
  /** 추천 */
  RECOMMENDED = 3,
  /** 핫딜 */
  HOT_DEAL = 4,
}

/** 교환/반품 유형 */
export enum ORDER_CLAIM_TYPE {
  /** 교환 */
  EXCHANGE = 'EXCHANGE',
  /** 반품 */
  RETURN = 'RETURN',
}

/** 교환/반품 상태 */
export enum ORDER_CLAIM_STATE {
  /** 요청 */
  PENDING = 'PENDING',
  /** 승인 */
  ACCEPTED = 'ACCEPTED',
  /** 거절 */
  REJECTED = 'REJECTED',
}

/** 귀책대상 유형 */
export enum CLAIM_FAULT_TYPE {
  /** 구매자 */
  BUYER = 'BUYER',
  /** 판매자 */
  SELLER = 'SELLER',
  /** 배송 */
  DELIVERY = 'DELIVERY',
  /** 상품 */
  PRODUCT = 'PRODUCT',
}

/** 기타 배송비 결제방법 */
export enum DELIVERY_FEE_PAYMENT_TYPE {
  /** 직접송금 */
  DIRECT_TRANSFER = 'DIRECT_TRANSFER',
  /** 환불금차감 @deprecated */
  REFUND_DEDUCTION = 'REFUND_DEDUCTION',
  /** 간편카드결제 */
  BILLING_KEY = 'BILLING_KEY',
  /** 일반카드결제 */
  CARD = 'CARD',
}

export const DELIVERY_FEE_PAYMENT_TYPES: { [key in DELIVERY_FEE_PAYMENT_TYPE]: string } = {
  [DELIVERY_FEE_PAYMENT_TYPE.DIRECT_TRANSFER]: '판매자에게 송금',
  [DELIVERY_FEE_PAYMENT_TYPE.REFUND_DEDUCTION]: '환불금에서 차감',
  [DELIVERY_FEE_PAYMENT_TYPE.BILLING_KEY]: '간편카드결제',
  [DELIVERY_FEE_PAYMENT_TYPE.CARD]: '일반카드결제',
}

/** 빌링결제 타입 */
export enum BILLING_PAYMENT_METHOD_TYPE {
  CARD = 'CARD',
  POINT = 'POINT',
  ACCOUNT_TRANSFER = 'ACCOUNT_TRANSFER',
}

/** 클라이언트 에러 메시지 */
export enum CLIENT_ERROR_MESSAGE {
  /** 주문상세조회시 주문상태 오류(주문대기o) */
  ORDER_IS_READY_ERROR = '결제가 완료되지 않은 주문입니다.',
  /** 주문상세조회시 주문상태 오류(주문대기x) */
  ORDER_IS_NOT_READY_ERROR = '결제가능한 주문이 아닙니다.',
}

/** 쇼핑몰 사유 타입 */
export enum SHOP_REASON_TYPE {
  /** 리뷰 신고사유 */
  REVIEW_REPORT = 'REVIEW_REPORT',
  /** 반품 사유 */
  RETURN = 'RETURN',
  /** 교환 사유 */
  EXCHANGE = 'EXCHANGE',
}

/** 주문 주소구분 */
export enum ORDER_ADDRESS_TYPE {
  /** 기본 */
  NONE = 'NONE',
  /** 제주 */
  JEJU = 'JEJU',
  /** 도서산간 */
  REMOTE = 'REMOTE',
}

/** 리스트 타입 */
export enum CONTENT_TYPE {
  BLOG = 'BLOG_CONTENT_TYPE',
  TIMELINE = 'TIMELINE_CONTENT_TYPE',
  MASONRY = 'MASONRY_CONTENT_TYPE', //
}

export enum LAYOUT_TYPE {
  IVADITRIP_TYPE = 'IVADITRIP_LAYOUT_TYPE',
  WECARE_TYPE = 'CONTENT_LAYOUT_TYPE',
}
